import PropTypes from "prop-types";
import { random, orderBy } from "lodash";
import { Icon } from "@iconify/react";
import heartFill from "@iconify/icons-eva/heart-fill";
import outlineFlightTakeoff from "@iconify/icons-ic/outline-flight-takeoff";
import trophyFilled from "@iconify/icons-ant-design/trophy-filled";
// material
import { alpha, styled } from "@material-ui/core/styles";
import {
  Box,
  Stack,
  Card,
  Avatar,
  CardHeader,
  Typography,
  Select,
} from "@material-ui/core";
// utils
import { fShortenNumber } from "../../../utils/formatNumber";
import mockData from "../../../utils/mock-data";
import { useFetch } from "src/hooks/useFetch";
import { decryptResponse } from "src/utils/decryptResponse";
import { decryptData } from "src/utils/decryptcookie";
import { FormControl, InputAdornment, InputLabel, MenuItem } from '@mui/material';
import { useState } from "react";

// ----------------------------------------------------------------------

const MOCK_AUTHORS = [...Array(4)].map((_, index) => ({
  id: mockData.id(index),
  name: mockData.name.allRoutes(index),
  avatar: mockData.image.avatar(index),
  favourite: random(9999, 19999),
  bookCount: random(100, 500),
}));

const IconWrapperStyle = styled("div")(({ theme }) => ({
  width: 40,
  height: 40,
  display: "flex",
  borderRadius: "50%",
  alignItems: "center",
  justifyContent: "center",
  color: theme.palette.primary.main,
  backgroundColor: alpha(theme.palette.primary.main, 0.08),
}));

// ----------------------------------------------------------------------

FlightDetials.propTypes = {
  author: PropTypes.shape({
    avatar: PropTypes.string,
    favourite: PropTypes.number,
    name: PropTypes.string,
  }),
  index: PropTypes.number,
};

function FlightDetials({ data, index }) {
  return (
    <Stack direction="row" alignItems="center" spacing={2}>
      <Avatar alt={data.name} src="../static/images/plain.png" />
      <Box sx={{ flexGrow: 1 }}>
        <Typography variant="subtitle2">{data.name}</Typography>
        <Typography
          variant="caption"
          sx={{
            mt: 0.5,
            display: "flex",
            alignItems: "center",
            color: "text.secondary",
          }}
        >
          <Box
            component={Icon}
            icon={outlineFlightTakeoff}
            sx={{ width: 16, height: 16, mr: 0.5 }}
          />
          {fShortenNumber(data.bookCount)}
        </Typography>
      </Box>

      <IconWrapperStyle
        sx={{
          ...(index === 1 && {
            color: "info.main",
            bgcolor: (theme) => alpha(theme.palette.info.main, 0.08),
          }),
          ...(index === 2 && {
            color: "error.main",
            bgcolor: (theme) => alpha(theme.palette.error.main, 0.08),
          }),
        }}
      >
        <Icon icon={trophyFilled} width={20} height={20} />
      </IconWrapperStyle>
    </Stack>
  );
}

export default function AppTopAuthors() {
  const displayAuthor = orderBy(MOCK_AUTHORS, ["favourite"], ["desc"]);
  
  let userCookie = decryptData("_b60-g6fr_plus");
  const [selectedValue, setSelectedValue] = useState('');

  const { data: getSubAgentList, isLoading: subAgentLoading } = useFetch(`/get/Subordinate`, { id: String(userCookie?.userid) });
  const subAgentList = getSubAgentList && decryptResponse(getSubAgentList?.response)?.map((item) => ({ ...item, userid: item.id }))

  const handleChange = (event) => {
    setSelectedValue(String(event.target.value));
    // bookingTableApi(event.target.value) // api call
  };


  return (
    <Card>
      <CardHeader title="Top Routes" action={<div className='w-[200px]'>
          <Box sx={{ minWidth: 120 }}>
            <FormControl fullWidth>
              {/* <InputLabel id="demo-simple-select-label">Select an option</InputLabel> */}
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={selectedValue}
                label="Select an option"
                onChange={handleChange}
              // IconComponent={() => null}
              // endAdornment={
              //     selectedValue ? (
              //       <InputAdornment position="end">
              //         <IconButton
              //           onClick={()=>setSelectedValue('')}
              //           // Prevent the dropdown from opening when clicking the clear button
              //           onMouseDown={(e) => e.stopPropagation()}
              //           edge="end"
              //           size="small"
              //         >
              //           <ClearIcon fontSize="small" />
              //         </IconButton>
              //       </InputAdornment>
              //     ) : null
              //   }
              >
                {selectedValue && <MenuItem
                  value={""}
                >
                  Clear
                </MenuItem>}
                {!subAgentLoading && subAgentList && subAgentList.length > 0 ? (
                  subAgentList.map((option) => {
                    if (option.Role == "manager") return null

                    return (

                      <MenuItem
                      key={option.User_id}
                        value={option.User_id}
                      >
                        {option.Name}
                      </MenuItem>
                    )
                  })
                ) : (
                  <MenuItem disabled>No agents available</MenuItem>
                )}
              </Select>
            </FormControl></Box>
        </div>} />
      <Stack spacing={3} sx={{ p: 3 }}>
        {displayAuthor.map((item, index) => (
          <FlightDetials key={index} data={item} index={index} />
        ))}
      </Stack>
    </Card>
  );
}
